import _ from 'lodash';
import axios from 'axios';
import i18next from 'i18next';

let exported = false;
export default function() {
  // Already exported ?
  if (exported) return;
  // Is connected ?
  if (
    document.getElementsByTagName('body')[0].attributes.class.value !==
    'logged-1'
  )
    return;
  // Clone the Root DOM, to make a local update on first child, in order
  // to put some opacity on the root node.
  const rootDOM = document.getElementById('root').cloneNode(true);
  if (rootDOM.children.length === 0) return;
  // Now just do a .server-render img{ opacity: 0 !important; }
  rootDOM.children[0].attributes.class.value += ' server-render';
  const innerHTML = _.trim(rootDOM.innerHTML);
  if (_.isEmpty(innerHTML) || innerHTML.length < 255) return;
  // Page reference, to index the cache
  const pageID = rootDOM.dataset.page;
  exported = true;
  // Get language
  const languages = [('fr': 'fr_FR'), ('en': 'en_GB'), ('es': 'es_ES')];
  let langParam = languages[i18next.language];
  if (_.isNil(langParam)) langParam = 'fr';
  axios
    .post(`/rs/save_dom?l=${langParam}`, {
      page: pageID,
      dom: _.trim(innerHTML),
    })
    .then(result => {
      console.log('serverside export done : ', result);
    });
}



// WEBPACK FOOTER //
// ./src/exportDOM.js